<template>
    <label class="text-sm font-medium text-iron-700 block">
        <span v-if="value">{{ value }}</span>
        <span v-else><slot></slot></span>
    </label>
</template>

<script>
export default {
    props: ["value"],
};
</script>
